export default function Body({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <div className="xl:w-9/12">
      <div className="grid grid-cols-1 gap-x-14 gap-y-9 xl:grid-cols-2 xl:gap-y-20">
        {children}
      </div>
    </div>
  );
}
